// extracted by css-extract-rspack-plugin
var _1 = "qmp5YXg9lWd7LQoukJDt-g--";
var _2 = "LFA5QlEL6FmwxWBaJ8fHLw--";
var _3 = "YtpGjunYjHVviFSrpu6IPA--";
var _4 = "GS-axnCK8kHapj20drHSkg--";
var _5 = "w2DBY9xGv3qbiiujmUbu2g--";
var _6 = "SvRlLJJex1-eWRBCD8NXuA--";
export { _1 as "blue", _2 as "dark", _3 as "gray", _4 as "light", _5 as "promoBadge", _6 as "white" }
